import InputField from "../common/InputField";
import React from "react";
import { Box, FormControl, Grid, InputLabel, Tooltip } from "@mui/material";
import { FormikErrors } from "formik";
import deleteButton from '../../images/icon-delete.svg';
import disabledDeleteButton from "../../images/disabled-icon-delete.svg";
import { useMediaQuery } from "react-responsive";
import { PoliticalExposurePoliticalAffiliateInformation } from "../../model/PoliticalExposureType";
import { useTranslation } from "react-i18next";

type PoliticalExposurePoliticalAffiliateInputProps = {
    index: number;
    handleValueChange: (value: any, field?: string) => void;
    handleValidation: (value: any, field?: string) => boolean;
    handleRemoval: (index: number) => void;
    isRemovalEnabled?: boolean;
    className?: string;
    error?: FormikErrors<PoliticalExposurePoliticalAffiliateInformation>;
    value?: PoliticalExposurePoliticalAffiliateInformation;
};

export const PoliticalExposurePoliticalAffiliateInput = ({
                                                             index,
                                                             handleValueChange,
                                                             handleValidation,
                                                             handleRemoval,
                                                             isRemovalEnabled = true,
                                                             error,
                                                             value,
                                                         }: PoliticalExposurePoliticalAffiliateInputProps) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isVerySmallMobile = useMediaQuery({ maxWidth: 350 });

    return (
      <FormControl sx={{ alignContent: 'center', color: 'black' }}>
          <InputLabel sx={{ backgroundColor: 'white', paddingInline: '6px', color: 'black' }} shrink>
            {t("political-exposure-page.political-affiliate.contact-list.info")}
          </InputLabel>
          <Box sx={{
              padding: '24px',
              borderWidth: '1px',
              borderRadius: '24px',
              borderColor: '#9C9FA3',
              backgroundColor: '#f9fafb',
          }}>
              <Grid container spacing={2}>
                  <Grid size={isMobile ? 12 : 5}>
                      <Grid container spacing={2}>
                          <Grid size={isMobile && !isVerySmallMobile ? 9 : 12}>
                              <InputField
                                name={`politickeOsobe[${index}].imePrezime`}
                                label={t("political-exposure-page.political-affiliate.contact-list.name-surname-field.label")}
                                maxLength={70}
                                inputValue={value?.imePrezime}
                                error={t(error?.imePrezime as string)}
                                handleValueChange={handleValueChange}
                                handleValidation={handleValidation}
                              />
                          </Grid>
                          {isMobile && !isVerySmallMobile &&
                            <PoliticalExposurePoliticalAffiliateInputRemoveButton
                              onClick={() => handleRemoval(index)}
                              isDisabled={!isRemovalEnabled}
                            />
                          }
                      </Grid>
                  </Grid>
                  <Grid size={isMobile ? 12 : 7}>
                      <Grid container spacing={2}>
                          <Grid size={isMobile ? 12 : 9}>
                              <InputField
                                className="md:ml-4"
                                name={`politickeOsobe[${index}].funkcija`}
                                label={t("political-exposure-page.political-affiliate.contact-list.function-field.label")}
                                maxLength={70}
                                inputValue={value?.funkcija}
                                error={t(error?.funkcija as string)}
                                handleValueChange={handleValueChange}
                                handleValidation={handleValidation}
                              />
                          </Grid>
                          {!isMobile &&
                            <PoliticalExposurePoliticalAffiliateInputRemoveButton
                              onClick={() => handleRemoval(index)}
                              isDisabled={!isRemovalEnabled}
                            />
                          }
                      </Grid>
                  </Grid>
                  {isVerySmallMobile &&
                    <PoliticalExposurePoliticalAffiliateInputRemoveButton
                      onClick={() => handleRemoval(index)}
                      isDisabled={!isRemovalEnabled}
                    />
                  }
              </Grid>
          </Box>
      </FormControl>
    );
}

type TaxResidencyCountryInputRemoveButtonProps = {
    onClick: () => void;
    isDisabled?: boolean;
}

const PoliticalExposurePoliticalAffiliateInputRemoveButton = ({
                                                                  onClick,
                                                                  isDisabled
                                                              }: TaxResidencyCountryInputRemoveButtonProps) => {
    const { t } = useTranslation();

    return (
      <div className="mt-3 mx-auto my-auto">
          <Tooltip
            slotProps={{
                tooltip: {
                    sx: {
                        fontSize: '14px',
                    },
                },
            }}
            placement="top"
            title={
                isDisabled ? undefined
                  : <span className={"font-base"} style={{ whiteSpace: 'pre-line' }}>{t("political-exposure-page.political-affiliate.side-relation.contacts-list.button-remove-person")}</span>
            }
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            arrow
          >
              <div>
                  <button
                    className="text-red-500 hover:text-red-700 shrink-0"
                    type="button"
                    onClick={onClick}
                    disabled={isDisabled}>
                      <img
                        className="w-8 h-8"
                        src={isDisabled ? disabledDeleteButton : deleteButton}
                        alt="Delete icon"
                      />
                  </button>
              </div>
          </Tooltip>
      </div>
    )
}
